﻿import { ICenterContactPosition, IDonorCompliance, IDonorWithRemoteRecipient, IMicrositeRecipientCompliance, IRecipientCompliance } from '..';
import { IPackagingRemittanceComplianceData } from './packaging-remittance-compliance-data';

import { IStrongBoxComplianceItem } from '../center-performance';
import { ICenterCompliance } from '../../models/center-performance';

export interface IActionCenterCompliance {
    activeRecipientsDataCompliance: IRecipientCompliance[],
    postTranplantRecipientsDataCompliance: IRecipientCompliance[],
    activeDonorsDataCompliance: IDonorCompliance[],
    activeRdnDonorsDataCompliance: IDonorCompliance[],
    postTranplantDonorsDataCompliance: IDonorCompliance[],
    postTranplantRdnDonorsDataCompliance: IDonorCompliance[],
    micrositeComplianceList: IMicrositeRecipientCompliance[],
    centerContactPositionList: ICenterContactPosition[],
    complianceWaitListAnatomyList: ICenterCompliance[],
    donorsWithRemoteRecipient: IDonorWithRemoteRecipient[],
    strongBoxComplianceList: IStrongBoxComplianceItem[],
    packagingRemittance: IPackagingRemittanceComplianceData
}

export interface IAdminActionCenterCompliance {
    complianceRecipientList: number,
    postTransplantComplianceRecipientList: number,
    complianceDonorList: number,
    complianceRdnDonorList: number,
    complianceWaitListAnatomyList: number,
    postTransplantComplianceDonorList: number,
    postTransplantComplianceRdnDonorList: number,
    centerContactsDataCompliance: number
}


